import type { ClockParts, Scenario, Slide } from "../domain/types";
import { isSlideAvailable } from "../domain/content-availability";

export function buildPlaylist(scenario: Scenario | undefined, clock: ClockParts, now = new Date()): Slide[] {
  if (!scenario) return [];
  return scenario.slides.filter((slide) => isSlideAvailable(slide, clock, now));
}
